import React from 'react';
import { compose, withProps } from 'recompose';
import { reduxForm, Field } from 'redux-form';
import Button from '@material-ui/core/Button';
import withStyles from '@material-ui/core/styles/withStyles';
import { TextField, Select } from 'redux-form-material-ui';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { get } from 'lodash';

const styles = theme => ({});
const required = value => (value || typeof value === 'number' ? undefined : 'Vyžadováno');
const valueCheck = (value, values) => {
  if (get(values, 'type', null) === 'int') {
    return Number.isInteger(parseFloat(value)) ? undefined : 'Musí být celé číslo';
  } else if (get(values, 'type', null) === 'double') {
    return parseFloat(value) ? undefined : 'Musí být desetinné číslo';
  } else if (get(values, 'type', null) === 'interval') {
    if (value.includes('-')) {
      const int = value.split('-').map(item => Number.isInteger(parseInt(item.trim(), 10)));
      return int.length === 2 && int.reduce((total, num) => total && num)
        ? undefined
        : 'Špatně zadaný interval';
    } else if (value.includes('+')) {
      return undefined;
    } else {
      return 'Špatně zadaný interval';
    }
  } else {
    return undefined;
  }
};
const enhance = compose(
  withStyles(styles),
  withRouter,
  withProps(({ match: { params: { attributeId, id } } }) => ({
    attributeId,
    id,
  })),
  reduxForm({ form: 'addAttributeValueForm' }),
);

export default enhance(({ classes, handleSubmit, setAddUser, history, attributeId }) => (
  <form className={classes.form} onSubmit={handleSubmit}>
    <Grid container spacing={24}>
      <Grid item xs={12}>
        <FormControl style={{ minWidth: 200 }}>
          <InputLabel htmlFor="type">Typ</InputLabel>
          <Field name="type" component={Select} placeholder={'vyberte'} validate={[required]}>
            <MenuItem value="interval">interval</MenuItem>
            <MenuItem value="string">text</MenuItem>
            <MenuItem value="int">celé číslo</MenuItem>
            <MenuItem value="double">desetinné číslo</MenuItem>
          </Field>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Field
          name="value"
          component={TextField}
          label="Hodnota"
          validate={[required, valueCheck]}
        />
      </Grid>
      <Grid item xs={12}>
        <Field name="unit" component={TextField} label="Jednotka" />
      </Grid>
    </Grid>
    <div style={{ margin: 20 }}>
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        Uložit
      </Button>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => history.push(`/attributes/${attributeId}`)}
      >
        Zrušit
      </Button>
    </div>
  </form>
));



// WEBPACK FOOTER //
// ./src/modules/attributes/form/addValueForm.js